// combatpro/panels/spells/SpellCard.js
//
// Combat PRO - SpellCard (functional migration of the spell system).
//
// Reproduces a single vi-spell-card from the spells-block template in
// battletracker.html (the three info cards: Auto Populate, Customise Spells,
// Random Spell). The card structure (title, body, foot) is identical across all
// three in the source, so it is one component used three times; the differing
// text is passed in via props so the exact wording is preserved verbatim by the
// caller (SpellWorkspace). No markup is invented.
//
// Imports only React. No state, hooks, handlers, or business logic. Do not edit
// battletracker.html.

import React from 'react';

function SpellCard(props) {
  return (
    <div className="vi-spell-card">
      <div className="vi-card-title">{props.title}</div>
      <div className="vi-card-body">{props.body}</div>
      <div className="vi-card-foot">{props.foot}</div>
    </div>
  );
}

export default SpellCard;
